import React, { useEffect, useState } from 'react';
import { NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Package, ShoppingBag, Newspaper, MessageSquare, LayoutDashboard, LogOut, Eye, BarChart3, Printer } from 'lucide-react';

const AdminLayout = () => {
  const [authed, setAuthed] = useState(!!localStorage.getItem('hh_admin_token'));
  const navigate = useNavigate();

  useEffect(() => {
    const onStorage = () => setAuthed(!!localStorage.getItem('hh_admin_token'));
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (!authed) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    localStorage.removeItem('hh_admin_token');
    navigate('/admin/login', { replace: true });
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded text-sm transition-colors ${
      isActive ? 'bg-[#909090] text-black font-semibold' : 'text-zinc-400 hover:text-white hover:bg-zinc-900'
    }`;

  return (
    <div className="min-h-screen bg-black text-white flex">
      <aside className="w-64 bg-zinc-950 border-r border-zinc-900 flex flex-col">
        <div className="p-6 border-b border-zinc-900">
          <p className="text-[10px] uppercase tracking-widest text-zinc-500">Admin</p>
          <p className="font-bold tracking-[0.18em] text-white text-lg mt-1">
            HYDRO <span className="text-[#909090]">HEALTH</span>
          </p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <NavLink to="/admin" end className={linkCls}><LayoutDashboard size={18}/> Dashboard</NavLink>
          <NavLink to="/admin/products" className={linkCls}><Package size={18}/> Products</NavLink>
          <NavLink to="/admin/labels" className={linkCls}><Printer size={18}/> Print Labels</NavLink>
          <NavLink to="/admin/orders" className={linkCls}><ShoppingBag size={18}/> Orders</NavLink>
          <NavLink to="/admin/news" className={linkCls}><Newspaper size={18}/> News</NavLink>
          <NavLink to="/admin/contacts" className={linkCls}><MessageSquare size={18}/> Contacts</NavLink>
          <NavLink to="/admin/analytics" className={linkCls}><BarChart3 size={18}/> Analytics</NavLink>
        </nav>
        <div className="p-3 border-t border-zinc-900 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded text-sm text-zinc-400 hover:text-white hover:bg-zinc-900">
            <Eye size={18}/> View site
          </a>
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded text-sm text-zinc-400 hover:text-red-400 hover:bg-zinc-900">
            <LogOut size={18}/> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
